import React from 'react';
import { GuestData } from '../types';
import { getWeddingConfig } from '../services/wedding-config';
import CoupleNames from './CoupleNames';
import CountdownTimer from './CountdownTimer';
import EventItinerary from './EventItinerary';
import VenueInfo from './VenueInfo';
import RSVPSection from './RSVPSection';
import PhotoGallery from './PhotoGallery';
import Footer from './Footer';
import DressCodeAndGifts from './DressCodeAndGifts';
import BibleVerse from './BibleVerse';

interface Props {
  guestData: GuestData;
}

const WeddingInvitation: React.FC<Props> = ({ guestData }) => {
  const config = getWeddingConfig();

  return (
    // <div className="wedding-invitation">
    //   <CoupleNames />
    //   <CountdownTimer weddingDate={config.weddingDate} />
    //   {/* <EventItinerary /> */}
    //   <DressCodeAndGifts />
    //   <VenueInfo />
    //   <RSVPSection guestData={guestData} />
    //   <Footer />
    // </div>
    <div className="wedding-invitation">
      <PhotoGallery guestCode={guestData.code} />
      <CoupleNames />
      <VenueInfo />
      <DressCodeAndGifts />
      <RSVPSection guestData={guestData} />
      <CountdownTimer weddingDate={config.weddingDate} />
      <BibleVerse />
      {/* <EventItinerary /> */}
      <Footer />
    </div>
  );
};

export default WeddingInvitation;